import {useDictionary} from '@adamlip/okeoke.client';
import {CircularProgress, Slider} from '@heroui/react';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import {UserContext} from 'contexts/UserContext';
import {useContext, useState} from 'react';
import toast from 'react-hot-toast';
import SendVibration from 'utils/Helpers-v1/SendVibration';

export default function ActivatePoints({onSuccess, onError}) {
	const {getValue} = useDictionary();

	const {userVipPoints, reserveLoading, setUsePoints} = useContext(UserContext);

	const [sliderValue, setSliderValue] = useState(0);

	const handleSetPoints = () => {
		if (reserveLoading) return null;
		if (typeof setUsePoints === 'function') {
			setUsePoints(sliderValue).then((res) => {
				if (res.success) {
					if (typeof onSuccess === 'function') {
						onSuccess(res.data);
					}
					toast.success(`${getValue('app_v2_vip_points_set_success')} - ${sliderValue}`);
					SendVibration('success');
				} else {
					if (typeof onError === 'function') {
						onError(res);
					}
					toast.error(getValue('app_v2_vip_points_set_failed'));
				}
			});
		}
	};

	return (
		<div className='w-full px-4 flex items-center justify-center flex-col'>
			{+userVipPoints < 100 && <div className='w-full text-center pb-4'>{getValue('app_v2_vip_points_not_enough')}</div>}
			{userVipPoints != null && +userVipPoints > 99 && (
				<>
					<Slider
						label={
							<>
								<span>{getValue('app_v2_vip_points_slider')}</span>
								<span className='text-[10px] font-light normal-case ml-2'>{getValue('app_v2_vip_points_slider_2')}</span>
							</>
						}
						step={100}
						maxValue={userVipPoints || 0}
						minValue={0}
						defaultValue={0}
						className='max-w-md'
						value={sliderValue}
						onChange={(e) => {
							setSliderValue(isNaN(e) ? 0 : e);
						}}
					/>
					<div className='text-center mt-2'>
						<div className='text-xs mb-2'>{getValue('app_v2_vip_points_desc')}</div>
						<BarSoftButton color='primary' disabled={reserveLoading} onPress={() => handleSetPoints()} className='min-w-[140px]'>
							{!reserveLoading && `${getValue('app_v2_vip_points_btn')} - ${sliderValue}`}
							{reserveLoading && <CircularProgress color='primary' size='sm' aria-label='aria label' />}
						</BarSoftButton>
					</div>
				</>
			)}
		</div>
	);
}
